const {default: HttpReference} = require('../platform/HttpReference');

export default class UserEmail extends HttpReference {
  async get() {
    return this.request();
  }
}
